// extracted by mini-css-extract-plugin
export default {"hamburger":"DrawerMenu_hamburger__nZI5Q","mainMenus":"DrawerMenu_mainMenus__OIuk1"};